import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "tw-px-6 tw-py-8 tw-mx-auto tw-w-full tw-bg-violet-400" }
const _hoisted_2 = { class: "tw-mx-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_main, null, {
        default: _withCtx(() => [
          _createElementVNode("nav", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_router_link, {
                to: "/",
                class: "tw-mx-4 tw-no-underline tw-text-violet-50"
              }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode("Home", -1)
                ]))]),
                _: 1
              }),
              (_ctx.isSignedIn)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: "/upload",
                    class: "tw-mx-4 tw-no-underline tw-text-violet-50"
                  }, {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                      _createTextVNode("Upload", -1)
                    ]))]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.isSignedIn)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    to: "/table",
                    class: "tw-mx-4 tw-no-underline tw-text-violet-50"
                  }, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createTextVNode("Table", -1)
                    ]))]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.isSignedIn)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 2,
                    to: "/trend",
                    class: "tw-mx-4 tw-no-underline tw-text-violet-50"
                  }, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createTextVNode(" Trend ", -1)
                    ]))]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.isSignedIn)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 3,
                    onClick: _ctx.googleSignOut,
                    class: "tw-float-right tw-text-violet-50",
                    size: "small",
                    elevation: "2",
                    variant: "text"
                  }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createTextVNode("Sign Out", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode(_component_router_view)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}